var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        visible: _vm.visible,
        id: "admin-production-type-edit-modal",
        title: "Edit Production Type",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Production Type Name" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("name") },
                model: {
                  value: _vm.formData.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.name",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("name") } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.formValidation.name) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Category Types" } },
            _vm._l(
              _vm.formData.category_types,
              function (categoryTypeId, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c(
                      "b-input-group",
                      [
                        _c("b-form-select", {
                          attrs: {
                            options: _vm.categoryTypes,
                            state: _vm.categoryTypeValid(index),
                          },
                          model: {
                            value: _vm.formData.category_types[index],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData.category_types, index, $$v)
                            },
                            expression: "formData.category_types[index]",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-input-group-append",
                          [
                            _vm.formData.category_types.length > 1
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      title: "remove category type",
                                      variant: "danger",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.removeCategoryType(index)
                                      },
                                    },
                                  },
                                  [_c("b-icon-x")],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  title: "add category type",
                                  variant: "success",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.addCategoryTypeRow.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_c("b-icon-plus")],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.categoryTypeValid(index) === false
                      ? _c(
                          "b-form-invalid-feedback",
                          { attrs: { state: _vm.categoryTypeValid(index) } },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formValidation[
                                    `category_types.${index}`
                                  ].replace(
                                    `category_types.${index}`,
                                    "category type"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.formData.category_types.length > 1
                      ? _c("hr")
                      : _vm._e(),
                  ],
                  1
                )
              }
            ),
            0
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "success",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n      Submit\n      "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }